import React from "react";
import styled from "styled-components";
import { Box, Card, Text } from "rebass";
import { Link } from "../styled/Link";

import { Scrollbar } from "../Scrollbar";

import { Header } from "./Header";
import { LibraryContent } from "./LibraryContent";

const LinkText = styled(Text)`
  transition: background-color .4s;

  &:hover {
    background-color: ${props => props.theme.colors["sp-gray"]};
  };
`;

export const Library: React.FC = () => (
  <Card
    height="100%"
    bg="#fff"
    borderRight="2px solid"
    borderColor="sp-gray"
    css="display: flex; flex-direction: column; overflow: hidden;"
  >
    <Header />

    <Box
      flex="1"
      css="overflow: hidden;"
    >
      <Scrollbar>
        {/* isScrolling will be override. It is transmitted to LibraryContent from Scrollbar */}
        <LibraryContent isScrolling />
      </Scrollbar>
    </Box>

    <Link to="/settings/report-issue">
      <LinkText
        py="16px"
        color="sp-blue"
        fontWeight="bold"
        textAlign="center"
      >
        Give Feedback
      </LinkText>
    </Link>
  </Card>
);
